import { Spacing, Text, Title } from '@vkontakte/vkui';
import vkMusicOutflowImage from 'img/subscriptions/vk_music_cancel_subs_mobile.png';
import React, { useCallback, useRef } from 'react';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { Button } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { disappearV2Plural } from 'reactApp/utils/pluralHelpers';

import styles from './VkMusicCancelSubscriptionMobile.css';

export interface VkMusicCancelSubscriptionMobileProps {
    subscription: BillingDataSubscriptionInfo;
    onClose: () => void;
    onSuccess: () => void;
    onAction: () => void;
    onShow: () => void;
}

const disappearPluralV2ByValue = (value?: string) => disappearV2Plural(parseInt(value || '0'));

export function VkMusicCancelSubscriptionMobile({
    onClose,
    onAction,
    onSuccess,
    onShow,
    subscription,
}: VkMusicCancelSubscriptionMobileProps) {
    const scrollRef = useRef<HTMLDivElement>(null);
    const value = subscription.space.value;

    const handleClick = useCallback(() => {
        onSuccess();
    }, [onSuccess]);

    const handleSecondaryClick = useCallback(() => {
        onAction();
    }, [onAction]);
    return (
        <MobileDialog onShow={onShow} onClose={onClose} closeOnDimmerClick scrollRef={scrollRef} mod="base" contextPadding="zero">
            <div ref={scrollRef} className={styles.rootMobile}>
                <img className={styles.image} src={vkMusicOutflowImage} alt="Если отключить автоплатёж, пропадут сразу два сервиса" />
                <div className={styles.content}>
                    <Title>Если отключить автоплатёж, пропадут сразу два сервиса</Title>
                    <Spacing size={8} />
                    <Text>
                        Вернётся реклама, {disappearPluralV2ByValue(value)} {value}. Нельзя будет слушать любимые треки с&nbsp;выключенным
                        экраном
                    </Text>
                </div>

                <div className={styles.buttonWrapper}>
                    <Button theme="vk" primary fluid onClick={handleClick}>
                        Сохранить два сервиса
                    </Button>
                    <Spacing size={12} />
                    <Button theme="vk" fluid onClick={handleSecondaryClick}>
                        Отключить
                    </Button>
                </div>
            </div>
        </MobileDialog>
    );
}
